/**
 * useBroadcasts — fetches admin-authored active broadcast messages
 * (public: works for guests and signed-in users).
 */
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface BroadcastMessage {
  id: string;
  title: string;
  body: string;
  cta_label: string | null;
  cta_url: string | null;
  priority: number;
  starts_at: string;
  ends_at: string | null;
}

export function useBroadcasts() {
  return useQuery<BroadcastMessage[]>({
    queryKey: ["broadcast-messages"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("broadcast_messages" as any)
        .select("id,title,body,cta_label,cta_url,priority,starts_at,ends_at")
        .eq("is_active", true)
        .order("priority", { ascending: false })
        .order("starts_at", { ascending: false })
        .limit(5);
      if (error) {
        // Silently degrade — banner is optional
        return [];
      }
      return ((data ?? []) as unknown) as BroadcastMessage[];
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
